import { Component } from '@angular/core';

@Component({
  templateUrl: './checkout.component.html',
  styleUrls: [
    './checkout.component.scss'
  ]
})
export class CheckoutComponent {

}



// WEBPACK FOOTER //
// ./src/app/checkout/checkout.component.ts